module.exports = __webpack_public_path__ + "image/human_1_44e46.png";